export default __webpack_public_path__ + "static/media/paginationLeft.7f66c945.svg";